<template>
  <div class="page-content" v-if="deviceInfos">
     <el-card class="cardTop" id="one">
       <h3 class="title" >基本信息</h3>
       <editBase
        :step="stepValidate.step1"
       :refresh="refresh"
       :productDetail="deviceInfos"
      operate="edit"/>
     </el-card>
     <el-card class="cardTop" id="two">
       <h3 class="title">扩展信息</h3>
       <editStep2
       :step="stepValidate.step2"
       :productDetail="deviceInfos"
      :expandDto="deviceInfos.expandVo"
      :refresh="refresh"
       operate="edit"
      @delImg="delImg"/>
     </el-card>
     <el-card class="cardTop" id="three">
       <h3 class="title">扩展信息</h3>
       <editStep3
       :step="stepValidate.step3"
        operate="edit"
       :refresh="refresh"
      :productDetail="deviceInfos"
      :expandDto="deviceInfos.expandVo"
      @delImg="delImg"/>
     </el-card>

     <el-card class="cardTop" id="four">
       <h3 class="title">扩展信息</h3>
       <editStep4
       :step="stepValidate.step4"
       operate="edit"
       :expandDto="deviceInfos.expandVo"
        :productDetail="deviceInfos"
        @delImg="delImg"/>
     </el-card>
     <el-row type="flex" justify="center" class="cardTop">
       <el-button @click="goDetail" type="">返回</el-button>
       <el-button @click="update" type="primary">修改</el-button>
     </el-row>
  </div>
</template>
<script>
import editBase from '@/components/product_control/productEdit/editStep1'
import editStep2 from '@/components/product_control/productEdit/editStep2'
import editStep3 from '@/components/product_control/productEdit/editStep3'
import editStep4 from '@/components/product_control/productEdit/editStep4'
import { getListById, editProduct } from '@/api/productRegistration'
import eventBus from '@/assets/js/eventBus'
import { deleteProductFile } from '@/api/fileServer'
export default {
  components: {
    editBase,
    editStep2,
    editStep3,
    editStep4
  },
  data () {
    return {
      brandOptions: [],
      tagOptions: [],
      delImgArr: [],
      deviceInfos: null,
      refresh: true,
      stepValidate: {
        step1: {
          next: false
        },
        step2: {
          next: false
        },
        step3: {
          next: false
        },
        step4: {
          next: false
        }
      }
    }
  },
  created () {
    eventBus.$on('addDelImg', this.addDelImg)
  },
  mounted () {
    this.getProductInfos()
  },
  methods: {
    goEdit () {
      this.$router.push(
        { path: '/productControl/productEdit', query: { productKey: this.$route.query.productKey } }
      )
    },
    goDetail () {
      const sRow = JSON.stringify({
        productKey: this.$route.query.productKey,
        productName: this.deviceInfos.productName
      })
      this.$router.push(
        { path: '/productControl/productDetail', query: { sRow: sRow } }
      )
    },
    // 验证不通过滚动到对应的锚点
    stepTo (id) {
      const ele = document.createElement('a')
      ele.href = '#' + id
      document.body.appendChild(ele)
      ele.click()
      document.body.removeChild(ele)
      // 使跳转地址同时恢复原样
      this.goEdit()
    },
    update () {
      this.stepValidate.step1.next = false
      this.stepValidate.step2.next = false
      this.stepValidate.step3.next = false
      this.stepValidate.step4.next = false
      eventBus.$emit('mergeParams')
      console.log('stepValidate:', this.stepValidate)
      console.log('更改后的详情：', this.deviceInfos)
      let next = true
      !this.stepValidate.step1.next ? (this.stepTo('one'), next = false) : ''
      !this.stepValidate.step2.next ? (this.stepTo('two'), next = false) : ''
      !this.stepValidate.step3.next ? (this.stepTo('three'), next = false) : ''
      !this.stepValidate.step4.next ? (this.stepTo('four'), next = false) : ''
      // if (!(this.stepValidate.step1.next && this.stepValidate.step2.next && this.stepValidate.step3.next && this.stepValidate.step4.next)) {
      //   return
      // }
      if (!next) {
        return
      }
      const params = Object.assign({}, this.deviceInfos)
      const expandDto = Object.assign({}, params.expandVo)
      // 删除多余参数
      delete params.expandVo
      if (expandDto && expandDto.agreementFile) {
        delete expandDto.agreementFile
      }
      expandDto.offlineInstructions = params.offlineInstructions;
      delete params.offlineInstructions;
      delete expandDto.configNet;
      params.expandDto = expandDto;
      console.log('更新的params：', params)
      editProduct({ params: params }).then(
        res => {
          if (res.data.code === 200) {
            this.productName = res.data.data.productName
            this.$message({
              type: 'success',
              message: '产品更新成功'
            })
            this.delImg()// 删除图片
            // 返回上一步详情页面
            const that = this
            setTimeout(function () {
              that.goDetail()
            }, 1000)
            // 刷新详情
            // this.getProductInfos()
            // this.$emit('closeDialog', 1)
          }
        }
      ).catch(e => {
        // 刷新详情
        this.getProductInfos()
      })
    },
    getProductInfos () {
      const params = {
        params: {
          productKey: this.$route.query.productKey
        }
      }
      getListById(params).then(
        res => {
          sessionStorage.setItem('deviceNum', res.data.data.deviceNum)
          const deviceInfos = Object.assign({
            expandVo: {}
          }, res.data.data)
          this.deviceInfos = deviceInfos
          debugger;
          this.refresh = !this.refresh
        }
      )
    },
    addDelImg (arr) {
      this.delImgArr = this.delImgArr.concat(arr)
      console.log('删除的delImgArr：', this.delImgArr)
    },
    delImg () {
      // 去重
      let imgArray = [...new Set(this.delImgArr)]
      imgArray = imgArray.filter(item => {
        return item !== ''
      })
      if (imgArray.length === 0) {
        return
      }
      deleteProductFile(imgArray).then(res => {
      }).catch(e => {
      })
      // 清空
      this.delImgArr.splice(0)
    }
  }
}
</script>
<style lang="less" scope>
.page-content{
  .title{
    width: 10%;
    padding: 5px 5px 5px 0;
    display: inline-block;
    margin-bottom: 10px;
    border-bottom: 1px solid #e6e2e2;
  }
  .cardTop{
    margin-top: 20px;
  }
}
</style>
